import request from '@/utils/request'

export function getRouterList() {
  return request({
    url:
      context.portal +
      '/sys/sysMenu/v1/getCurrentUserMenu?menuAlias=front_menu',
    method: 'get',
  })
}
